export const CITY_TYPE_CALI = 'Cali'
export const CITY_TYPE_TUMACO = 'Tumaco'
export const CITY_TYPE_MEDELLIN = 'Medellin'
